import { render, staticRenderFns } from "./LoginWithBitbucketButton.vue?vue&type=template&id=4f7e13d6&scoped=true"
import script from "./LoginWithBitbucketButton.vue?vue&type=script&lang=ts"
export * from "./LoginWithBitbucketButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e13d6",
  null
  
)

export default component.exports